/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {updateAliasNotificationSettings} from '../api'

export const useMutationUpdateAliasNotificationSettings = createReactQueryMutationHook('updateAliasNotificationSettings', updateAliasNotificationSettings)
